export default __webpack_public_path__ + "static/media/empty_permanents.e3619c29.png";